<template>
  <a-drawer
    placement="right"
    :visible="visible"
    :closable="true"
    :mask-closable="false"
    width="50%"
    wrap-class-name="filter-drawer"
    @close="onClose"
  >
    <div
      slot="title"
      class="title clearfix"
    >
      <h2 class="fl">
        {{ $t('message["960"]') }}
      </h2>
    </div>

    <div
      v-if="!loading"
      class="form"
      :class="{'en-form': isEnglish}"
    >
      <template v-if="filterResult && filterResult.length">
        <div
          v-for="(item) in filterResult"
          :key="item.fileldkey"
          class="clearfix"
        >
          <filter-item
            :data="item"
            :userid="quitName.userid"
            :dia="visible"
          />
        </div>
      </template>
    </div>
    <a-spin v-else />
    <div class="footer">
      <a-button
        type="primary"
        @click="handleOk"
      >
        {{ $t('message["915"]') }}
      </a-button>
      <a-button
        :style="{marginRight: '8px'}"
        @click="handleCancel"
      >
        {{ $t('message["736"]') }}
      </a-button>
    </div>
  </a-drawer>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import FilterItem from './FilterItem'
import { getLang } from '@/lib/storage'

export default {
  components: {
    FilterItem
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isVisible: false,
      confirmLoading: false
    }
  },
  computed: {
    ...mapState('quit', ['quitName', 'loading', 'filterResult']),
    isEnglish () {
      return this.getLang() === 'en'
    }
  },
  watch: {
    visible (val) {
      this.isVisible = val
    }
  },
  created () {
    // this.getQuery()
  },
  methods: {
    ...mapMutations('quit', ['setFilterResult']),
    getLang,
    /* ...mapActions('inquery/filterData', ['fetchQuery']),
    async getQuery () {
      const chain = await this.fetchQuery()
      chain
        .params()
        .fetch()
    }, */
    hide () {
      this.$emit('update:visible', false)
    },
    reset () {
      // 清空表单数据
    },
    onClose () {
      this.hide()
      this.reset()
    },
    handleOk () {
      this.$emit('handleFilterData', true)
      this.setFilterResult(this.filterResult)
      this.hide()
      // this.reset()
    },
    handleCancel () {
      this.hide()
      this.reset()
      this.setFilterResult([])
      this.$emit('handleFilterData', false)
    }
    /* setFilterUrlData (type) {
      let obj = {}
      for (let item of this.filterFormData) {
        let one = {}
        one.fieldtype = item.fieldtype
        one.fieldkey = item.fieldtype
        one.fieldvalue = item.fieldvalue
        obj[item.fieldkey] = one
      }
      return obj
    } */
  }
}
</script>

<style lang="scss" scoped>
  .en-form::v-deep {
  .ant-form-item-label {
    width: 200px;
    text-overflow: ellipsis;
    label {
      white-space: nowrap;
    }
  }
  .ant-form-item-control-wrapper {
    padding-left: 200px;
  }
   .ant-form-item-label label::after{
    content: '';
  }
  .ant-form-item-label::after {
    content: ':';
    position: absolute;
    left: 182px;
    top: 0;
    color: #666;
  }
}
</style>
<style lang="scss">
.filter-drawer {
  .ant-drawer-content-wrapper {
    min-width: 600px;
  }
  .ant-drawer-content {
    padding: 0;
    border-bottom: none;
  }
  .ant-drawer-header {
    padding: 32px 40px;
    border-bottom: none;
  }
  .ant-drawer-title h2 {
    font-size: 32px;
    font-weight: 600;
  }
  .ant-drawer-body {
    padding: 0;
    .form {
      padding: 0 40px 64px;
    }
  }
  .more-btn {
    margin: 5px 0 0 16px;
    font-size: 14px;
  }
  .ant-drawer-close {
    top: 20px;
    right: 20px;
    .ant-drawer-close-x {
       width: 32px;
    height: 32px;
    line-height: 32px;
    font-size: 32px;
    color: #ccc;
    }
  }
  .footer {
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 99;
    width: 100%;
    padding: 16px 0 16px 180px;
    border-top: 1px solid $gray4;
    background: #fff;
  }
}
</style>
